export const LogoImages = {
  cyphlensLogo: require('./cyphlensLogo.svg'),
  cyphlens: require('./cyphlens.svg'),
};
